
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "ShoppingListRecommendationPageIndicator",
  props: {
    /** 位置 */
    index: {
      type: Number,
      required: true
    },
    /** 選択 */
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    return {
    };
  }
});
